var _defs, _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #666;\n        stroke-miterlimit: 10;\n        stroke-width: .2px;\n      }\n\n      .cls-2 {\n        fill: #c1253c;\n      }\n\n      .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #2d3577;\n      }\n\n      .cls-4 {\n        fill: #fefefe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 15.6,
    cy: 15.5,
    r: 14.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8,11.4l-5.2-3.3c.3-.5.6-.9.9-1.4l7.4,4.7h-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.7,20.2l-5.5,3.5c-.3-.5-.6-.9-.8-1.4l3.2-2.1h3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.6,8.8l-4.1,2.6h-3.1l6.3-4.1c.3.5.6.9.8,1.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.2,20.2l5.5,3.5c-.3.5-.6.9-1,1.3l-7.5-4.8h3.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.9,1.2v9.5l-7.5-4.8c1.9-2.2,4.6-3.9,7.5-4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.5,5.7l-7.8,5V1.1c3.1.7,5.7,2.3,7.8,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.8,10.1l2.1,1.3H1.3c.1-.5.3-.9.5-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.5,20.2h2.3l-1.8,1.1c-.2-.4-.2-.3-.4-.7l-.2-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.7,29.9v-9l7.4,4.7c-2,2.1-4.5,3.6-7.4,4.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.7,25.5l7.2-4.6v8.9c-2.8-.7-5.3-2.2-7.2-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.9,21.6l-2.2-1.4h2.7c-.2.5-.3.9-.5,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.7,11.4h-2.9l2.4-1.5c.2.5.4,1,.5,1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.4.9v12.3h12.7c.1.8.2,1.5.2,2.3s-.1,2-.3,2.9h-12.6v11.7c-.6,0-1.2.1-1.9.1s-1.5,0-2.2-.2v-11.6H1.1c-.2-.9-.3-1.9-.3-2.9s0-1.6.2-2.3h12.3V1c.7-.1,1.5-.2,2.2-.2s1.3,0,1.9.1Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 15.5,
    cy: 15.5,
    r: 14.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEng);
export default __webpack_public_path__ + "static/media/eng.98e5687c68cc91d1c2fdd6be7072970f.svg";
export { ForwardRef as ReactComponent };